<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">我的会议</span>
      </div>
    </div>
    <div v-if="meetinglist.mymeetinglist.length > 0">
      <div class="display_between marginTop20"
           v-for="(item, index) in meetinglist.mymeetinglist"
           :key="index + '1'">
        <div class="pub_square"
             v-for="(itemx, indexx) in item"
             :key="indexx + '11'"
             @click="meetinginfo(itemx.id)">
          <div class="pubs_img">
            <img class="pubs_img"
                 :src="itemx.mtg_Image_ResUrl" />
          </div>
          <div class="pubs_body">
            <div class="pubs_title"
                 :title="itemx.title">{{ ellipsis(itemx.mtg_Name, 17) }}</div>
          </div>
          <div class="display_between">
            <div class="pubs_tip pubs_body">
              <span>会议报名截止日期:</span>
              <span class="normalColor"> {{ formatTime(itemx.mtg_Req_EndTime, 'YYYY-MM-DD') }}</span>
            </div>
          </div>
          <div class="display_between">
            <div class="pubs_tip pubs_body">
              <span>会议时间:</span>
              <span class="normalColor"> {{ formatTime(itemx.mtg_StartTime, 'YYYY-MM-DD') }} 至 {{ formatTime(itemx.mtg_EndTime, 'YYYY-MM-DD') }}</span>
            </div>
          </div>
        </div>
        <div class="pub_square1"
             v-for="zhw in 3 - item.length"
             :key="zhw"></div>
      </div>
    </div>
    <div v-else>
      <ul class="NoneData">
        <p>
          <span>您还没有报名过任何会议！</span>
        </p>
      </ul>
    </div>
    <div class="gl_title_bar marginBottom10 marginTop20"
         v-if="meetinglist.startlist.length > 0">
      <div class="gl_tb_left">
        <span class="normaltitle">报名中</span>
      </div>
    </div>
    <div class="display_between marginTop20"
         v-for="(item, index) in meetinglist.startlist"
         :key="index + '2'">
      <div class="pub_square"
           v-for="(itemx, indexx) in item"
           :key="indexx + '21'"
           @click="meetinginfo(itemx.id)">
        <div class="pubs_img">
          <img class="pubs_img"
               :src="itemx.mtg_Image_ResUrl" />
        </div>
        <div class="pubs_body">
          <div class="pubs_title"
               :title="itemx.title">{{ ellipsis(itemx.mtg_Name, 17) }}</div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>会议报名截止日期:</span>
            <span class="normalColor"> {{ formatTime(itemx.mtg_Req_EndTime, 'YYYY-MM-DD') }}</span>
          </div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>会议时间:</span>
            <span class="normalColor"> {{ formatTime(itemx.mtg_StartTime, 'YYYY-MM-DD') }} 至 {{ formatTime(itemx.mtg_EndTime, 'YYYY-MM-DD') }}</span>
          </div>
        </div>
      </div>
      <div class="pub_square1"
           v-for="zhw in 3 - item.length"
           :key="zhw"></div>
    </div>
    <div class="gl_title_bar marginBottom10 marginTop20"
         v-if="meetinglist.endlist.length > 0">
      <div class="gl_tb_left">
        <span class="normaltitle">已结束</span>
      </div>
    </div>
    <div class="display_between marginTop20"
         v-for="(item, index) in meetinglist.endlist"
         :key="index + '3'">
      <div class="pub_square"
           v-for="(itemx, indexx) in item"
           :key="indexx + '31'"
           @click="meetinginfo(itemx.id)">
        <div class="pubs_img">
          <img class="pubs_img"
               :src="itemx.mtg_Image_ResUrl" />
        </div>
        <div class="pubs_body">
          <div class="pubs_title"
               :title="itemx.title">{{ ellipsis(itemx.mtg_Name, 17) }}</div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>会议报名截止日期:</span>
            <span class="normalColor"> {{ formatTime(itemx.mtg_Req_EndTime, 'YYYY-MM-DD') }}</span>
          </div>
        </div>
        <div class="display_between">
          <div class="pubs_tip pubs_body">
            <span>会议时间:</span>
            <span class="normalColor"> {{ formatTime(itemx.mtg_StartTime, 'YYYY-MM-DD') }} 至 {{ formatTime(itemx.mtg_EndTime, 'YYYY-MM-DD') }}</span>
          </div>
        </div>
      </div>
      <div class="pub_square1"
           v-for="zhw in 3 - item.length"
           :key="zhw"></div>
    </div>
  </div>
</template>
<script>
import format from '@/assets/unit/unit.js';
import lodash from 'lodash';
export default {
  name: 'userMyMeeting',
  data () {
    return {
      trainmeetinglist: [], //全部会议
      AuthorId: 0,
      meetinglist: {
        endlist: [],
        startlist: [],
        mymeetinglist: []
      }
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    this.getTrainMeetingList();
  },
  methods: {
    /*全国全科会议及培训*/
    getTrainMeetingList () {
      let _this = this;
      this.httphelper
        .post('/api/MeetingApi/GetMeetingList', {
          mtgType: 0,
          userId: this.AuthorId
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.meetinglist.endlist = lodash.chunk(res.data.data.endlist, 3);
            _this.meetinglist.startlist = lodash.chunk(res.data.data.startlist, 3);
            _this.meetinglist.mymeetinglist = lodash.chunk(res.data.data.mylist, 3);
          }
        });
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    meetinginfo (mtgid) {
      const { href } = this.$router.resolve({
        path: '/meetingIndex/meetingpc',
        query: { mid: mtgid }
      });
      window.open(href, '_blank');
    }
  }
};
</script>
<style>
.pubs_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    font-weight: bold;
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 块状列表 */
.pub_square {
    width: 300px;
    height: 280px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
}
.pub_square1 {
    width: 300px;
    height: 280px;
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04); */
}
.NoneData {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 18px;
    letter-spacing: 1px;
}
</style>
